import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

/**
 * De pagina voor een adres dat niet bestaat.
 * @returns De pagina.
 */
export function NietGevonden() {
  return (
    <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
      <Typography variant="h4" component="h1">
        Pagina niet gevonden
      </Typography>
      <Typography color="text.secondary">Dit adres bestaat niet of is verplaatst.</Typography>
      <Button component={Link} to="/" nativeButton={false} variant="contained">
        Naar het dashboard
      </Button>
    </Stack>
  );
}
